import {SearchableRow} from "./types";

export function prepareSearchableString<T>(row: T, searchProperties: (keyof T)[]): string {
  return searchProperties
    .map(property => (row[property] ?? '').toString())
    .join('|')
    .toLowerCase()
}

export function enrichRowWithSearchableString<T>(rows: T[], searchProperties: (keyof T)[]): SearchableRow<T>[] {
  return rows.map((row) => {
    return {
      ...row,
      _searchable: prepareSearchableString(row, searchProperties),
    }
  })
}

export function searchRows<T>(rows: SearchableRow<T>[], search: string): SearchableRow<T>[] {
  if (search.trim().length === 0) {
    return rows
  }
  return rows.filter(row => row._searchable.includes(search.trim().toLowerCase()))
}

export function sortRows<T>(rows: T[], sortDirection: 'ASC'|'DESC'|null, sortColumn: (keyof T)|null): T[] {
  if (sortDirection === null || sortColumn === null) {
    return rows
  } else {
    const sortFactor = sortDirection === "ASC" ? 1 : -1
    return rows.sort((a, b) => {
      if (a[sortColumn] > b[sortColumn]) {
        return sortFactor
      } else {
        return -sortFactor
      }
    })
  }
}

export function paginateRows<T>(rows: T[], page: number, paginateSize: number): T[] {
  if (rows.length < paginateSize) {
    return rows
  }
  return rows.slice((page-1)*paginateSize, (page-1)*paginateSize + paginateSize)
}

